import { render, staticRenderFns } from "./TermsCheckbox.vue?vue&type=template&id=28901cc5&scoped=true&"
import script from "./TermsCheckbox.vue?vue&type=script&lang=js&"
export * from "./TermsCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./TermsCheckbox.vue?vue&type=style&index=0&id=28901cc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28901cc5",
  null
  
)

export default component.exports